import { render, staticRenderFns } from "./passenger-tooltip.vue?vue&type=template&id=1b2b2b65&scoped=true&"
import script from "./passenger-tooltip.vue?vue&type=script&lang=js&"
export * from "./passenger-tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b2b65",
  null
  
)

export default component.exports